import { takeEvery, takeLatest } from 'redux-saga/effects';
import { EVACUATIONS_MODULE } from '../../../configs/moduleNames';
import {
  LOAD_EVACUATIONS_LIST,
  CREATE_EVACUATIONS,
  DELETE_EVACUATIONS,
  EDIT_EVACUATIONS_BY_ID,
  LOAD_EVACUATIONS_BY_ID,
} from '../actions';

import loadEvacuationsList from './loadEvacuationsList';
import createEvacuations from './createEvacuations';
import loadEvacuationsById from './loadEvacuationsById';
import editEvacuationsById from './editEvacuationsById';
import deleteEvacuations from './deleteEvacuations';

export default function* watchDashboard() {
  yield takeLatest(EVACUATIONS_MODULE + LOAD_EVACUATIONS_LIST, loadEvacuationsList);
  yield takeLatest(EVACUATIONS_MODULE + CREATE_EVACUATIONS, createEvacuations);
  yield takeEvery(EVACUATIONS_MODULE + LOAD_EVACUATIONS_BY_ID, loadEvacuationsById);
  yield takeEvery(EVACUATIONS_MODULE + EDIT_EVACUATIONS_BY_ID, editEvacuationsById);
  yield takeEvery(EVACUATIONS_MODULE + DELETE_EVACUATIONS, deleteEvacuations);
}
